import { APIStatus } from "@application/common/enums/api-status";
import { createSlice } from "@reduxjs/toolkit";
import { archivingTogglingInvitationAsync, deleteInvitationAsync, ExportToExcelAsync, getAllInvitationCountAsync, getInvitationDatesByInvitationIdAsync, getInvitationDatesByUserIdAsync, getInvitationDatesForByInvitationIdWithPreAccDateAsync, getInvitationStatsAsync, getPaginatedInvitationsByEventIdAsync, } from "./invitationThunk";
const initialState = {
    status: APIStatus.IDLE,
    invitationCounts: null,
    paginatedInvitations: null,
    apiError: undefined,
    deleteSuccess: null,
    archivingTogglelingSuccess: null,
    invitationStats: null,
    invitationDates: null,
    invitationDatesForAccommodation: null,
    userInvitationDates: null,
};
export const invitationSlice = createSlice({
    name: "invitation",
    initialState,
    reducers: {
        clearInvitationCounts: (state) => {
            state.invitationCounts = null;
        },
        clearPaginatedInvitations: (state) => {
            state.paginatedInvitations = null;
        },
        clearDeleteSuccess: (state) => {
            state.deleteSuccess = null;
        },
        clearInvitationStats: (state) => {
            state.invitationStats = null;
        },
        clearInvitationDates: (state) => {
            state.invitationDates = null;
        },
        clearUserInvitationDates: (state) => {
            state.userInvitationDates = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllInvitationCountAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllInvitationCountAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.invitationCounts = action.payload;
        })
            .addCase(getAllInvitationCountAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getPaginatedInvitationsByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPaginatedInvitationsByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.paginatedInvitations = action.payload;
        })
            .addCase(getPaginatedInvitationsByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(ExportToExcelAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(ExportToExcelAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.paginatedInvitationsToExportInExcel = action.payload;
        })
            .addCase(ExportToExcelAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteInvitationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
            state.deleteSuccess = null;
        })
            .addCase(deleteInvitationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.deleteSuccess = action.payload.data;
        })
            .addCase(deleteInvitationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
            state.deleteSuccess = null;
        });
        builder
            .addCase(archivingTogglingInvitationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
            state.archivingTogglelingSuccess = null;
        })
            .addCase(archivingTogglingInvitationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.archivingTogglelingSuccess = action.payload.data;
        })
            .addCase(archivingTogglingInvitationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
            state.archivingTogglelingSuccess = null;
        });
        builder
            .addCase(getInvitationStatsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getInvitationStatsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.invitationStats = action.payload.data;
        })
            .addCase(getInvitationStatsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getInvitationDatesByInvitationIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getInvitationDatesByInvitationIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.invitationDates = action.payload;
        })
            .addCase(getInvitationDatesByInvitationIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getInvitationDatesForByInvitationIdWithPreAccDateAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getInvitationDatesForByInvitationIdWithPreAccDateAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.invitationDatesForAccommodation = action.payload;
        })
            .addCase(getInvitationDatesForByInvitationIdWithPreAccDateAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getInvitationDatesByUserIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getInvitationDatesByUserIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.userInvitationDates = action.payload;
        })
            .addCase(getInvitationDatesByUserIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    },
});
export const { clearUserInvitationDates, clearInvitationDates, clearInvitationStats, clearInvitationCounts, clearPaginatedInvitations, clearDeleteSuccess, } = invitationSlice.actions;
export default invitationSlice.reducer;
